import * as React from "react";
import { toINR } from "../../../../service/numberFormat";

export interface IHoldEqSmallcaseRowDskProps {
	rowData: any;
}

const HoldEqSmallcaseRowDsk: React.FC<IHoldEqSmallcaseRowDskProps> = props => {
	return (
		<li className="data_row">
			<div className="col stockName robotoM">
				<span dangerouslySetInnerHTML={{ __html: props.rowData.stockName }}></span>
			</div>
			<div className="col shares w_80">{toINR(props.rowData.shares)}</div>
			<div className="col ltp w_80">{toINR(props.rowData.ltp)}</div>
			<div className="col averagePrice w_90">{toINR(props.rowData.averagePrice)}</div>
		</li>
	);
};

export default HoldEqSmallcaseRowDsk;
